import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, Expo, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list, Mix } from "Utils/Reflection";
import * as Constants from "Data/Constants";

import {ch1_p09} from "../../../layouts/ch1_p09/ch1_p09";

export class Chapter1Page9 extends AbstractStoryState {

	readonly background = this.addChild(new SceneSprite());
	readonly island = this.addChild(new SceneSprite());
	readonly light = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(new SceneSprite());
    readonly frameRight = this.addChild(new SceneSprite());
	readonly lineart = this.addChild(new SceneSprite());
	readonly holly = this.addChild(new SceneSprite());

	dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layout from Animate CC
        ch1_p09.call(this);

        // interaction

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public animateIn(pOnComplete: ()=>void): void {
		super.animateIn(pOnComplete);
		const d = 5;
		const t = new TimelineLite();

		const ease = Expo.easeOut;

		// horizon
		const center = {x: 0.5, y: 0.75};
		const containerPos = {
			x: (Constants.SCENE_WIDTH * center.x),
			y: (Constants.SCENE_HEIGHT * center.y),
		};

		// set background, line art, and lights to same z depth
		this.background.z = 3;
		this.light.z=3;
		this.lineart.z = 3;
		this.island.z = 2;
		this.holly.z = 1;

		const childrenToAnimate = [
			this.background,
			this.island,
			this.light,
			this.lineart,
			this.holly,
		]

		// parallax
		for (let i = childrenToAnimate.length-1; i >= 0; --i) {
			const siblingIndex = this.getChildIndex(childrenToAnimate[i]);
			const child = this.removeChild(childrenToAnimate[i]);
			const container = this.addChildAt(new PIXI.Container(), siblingIndex);
			container.name = child.name + "_parallax";
			container.position.set(containerPos.x, containerPos.y);
			child.setParent(container);
			HLF.PointUtils.subtractFromPoint(child.position, container.position);
			const fromScale = 1.1 + ((4-child.z) / 10); // TODO
			t.fromTo(container, d, {pixi: {scale: fromScale}}, {pixi: {scale: 1}, ease}, 0);
		};

		// slide in holly from left
		const hollyContainer = this.holly.parent;
		t.from(hollyContainer, d, {pixi: {
			x: hollyContainer.x - 100,
		}, ease}, 0);

		// fade in watercolor edges
		t.from([this.frameLeft, this.frameRight, this.lineart], d, {pixi: {alpha: 0}}, 0);

		// fade in light
		t.from(this.light, 1.5, {pixi: {alpha: 0.2}}, 3);

		// fade out old background music
		const prevLoop = Application.instance.audio.getAudioTrack("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM);
		prevLoop?.fadeTo(0, 1000);
		prevLoop?.once(HLF.HowlerUtils.Events.FADE, ()=>{
			prevLoop.unloadSource();
		});

		// play new background music
		const intro = Application.instance.audio.createAudioTrack("HH_Ch1_LoopB_IntroElement", HLF.AudioCategory.BGM);
		const mainLoop = Application.instance.audio.createAudioTrack("HH_Ch1_LoopB_MainLoop", HLF.AudioCategory.BGM);
		mainLoop.setLooped(true);
		intro.play();
		intro.once(HLF.HowlerUtils.Events.END, ()=>{
			mainLoop.play();
			intro.unloadSource();
		});
	}

	protected onAnimateInComplete() {
		TweenLite.delayedCall(5, () => {
			HLF.Application.instance.audio.play("HollyPhoneVibrate", 2, true, HLF.AudioCategory.SFX);
			super.onAnimateInComplete();
		});
		TweenLite.delayedCall(6.5, () => this.gotoNextState({transition: "left"}));
	}
}